<template>
    <div id="nav" class="nav-scroller rounded py-1 mb-5">
       <nav class="nav d-flex justify-content-between rounded">
            <router-link class="p-2 text-white" to="/">Home</router-link>
            <router-link class="p-2 text-white" to="/about">About</router-link>
            <router-link class="p-2 text-white" to="/players">Players</router-link>
            <router-link class="p-2 text-white" to="/results">Results</router-link>
            <router-link class="p-2 text-white" to="/stats">Stats</router-link>
            <router-link class="p-2 text-white" to="/venues">Venues</router-link>
        </nav>    
    </div>
</template>

<script>
export default {
    
}
</script>




// WEBPACK FOOTER //
// src/components/Navbar.vue